import axios from "axios";
import store from "../store/store";
import {
  getManualApiBasePath,
  resolveManualTypeFromPathname,
} from "../util/platformNavigation";

const resolveApiBasePath = () => {
  const manualType = store.getState().manualTypeChecker.manualType;
  const platformType = store.getState().platformTypeChecker.platformType;

  if (manualType) {
    return getManualApiBasePath(manualType, platformType);
  }

  const fromPath = resolveManualTypeFromPathname(window.location.pathname);
  return getManualApiBasePath(fromPath.manualType, fromPath.platformType);
};

export const setupAxiosInterceptors = () => {
  if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = "http://localhost:9999";
  }

  axios.interceptors.request.use((config) => {
    const url = config.url ?? "";
    if (url.startsWith("/api/manual") || url.startsWith("/api/snb")) {
      const basePath = resolveApiBasePath();
      if (basePath) {
        config.url = `/api/${basePath}/${url.substring(5)}`;
      }
    }
    return config;
  });
};
